/* AI-Drop / Lunaice: analityka zachowań na stronie (2026-10-26; opis, schemat i sposób czytania: docs/ANALITYKA.md).
   Własny pomiar obok Shopify i piksela Meta: one mówią, ILE osób weszło i kupiło, ten plik mówi, GDZIE na stronie
   coś je zatrzymało albo zgubiło. Każde zdarzenie niesie wersję motywu (window.Shopify.theme), więc każde wydanie
   „Lunaice RRRR-MM-DD …” da się porównać z poprzednim bez ręcznego notowania dat.
   Co zbiera:
   - sesje i odsłony: źródło (UTM, fbclid/gclid tylko jako „był”, host strony odsyłającej), przeglądarka w aplikacji
     (Facebook/Instagram/TikTok), urządzenie; przy wyjściu podsumowanie odsłony (czas aktywny, przewinięcie, czas
     w każdej sekcji i w każdej strefie karty produktu, kolejność oglądania);
   - sekcje i strefy, które ktoś zobaczył (≥ 50 % elementu albo ≥ 30 % ekranu), kafle produktów (wyświetlenie i hover);
   - kliknięcia z miejscem w elemencie (mapa kliknięć: selektor od sekcji + położenie 0–1), kliknięcia „martwe”
     (w coś, co nic nie zrobiło przez 1 s) i „wściekłe” (3 w 0,8 s w jednym miejscu);
   - koszyk: każde /cart/add i /cart/change z miejscem, z którego kliknięto, szuflada, przejście do kasy; po pierwszym
     dodaniu w sesji koszyk dostaje ukryte atrybuty _ln_v/_ln_s, więc zamówienie w Shopify łączy się z sesją;
   - akordeony i pytania, wybór długości, galerię, zdarzenia motywu z konfiguracji (np. przełącznik światła),
     formularze (start i wysłanie – nigdy treść), błędy JS i plików, szybkość (Core Web Vitals z elementem winnym).
   Kasa Shopify to osobny piksel w panelu (packages/analityka/piksel-kasy.js), który czyta te same ciasteczka.
   Prywatność: nic nie startuje bez zgody na analitykę z banera Shopify (Customer Privacy API); po jej cofnięciu
   ciasteczka _ln_v/_ln_s są kasowane. Bez IP, bez wartości pól, bez tekstów na stronach konta (page.private).
   Ruch właściciela: ?ln_internal=1 (ciasteczko _ln_int, raport go pomija; ?ln_internal=0 zdejmuje); roboty
   (navigator.webdriver, Lighthouse) i podgląd nieopublikowanego motywu są oznaczane, nie odrzucane.
   Konfiguracja w window.LN_ANALITYKA (snippet ln-analityka.liquid); plik nie zna Lunaice – nowy sklep = nowy snippet.
   Wszystko w try/catch: błąd pomiaru nigdy nie może zepsuć sklepu. */
(() => {
  if (window.LnAnalityka) return;
  const CFG = window.LN_ANALITYKA;
  if (!CFG || !CFG.endpoint || (window.Shopify && window.Shopify.designMode)) return;

  const doc = document;
  const root = doc.documentElement;
  const perf = window.performance;
  const nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  const T0 = Math.round(perf && perf.timeOrigin ? perf.timeOrigin : Date.now());
  const since = () => Math.round(perf && perf.now ? perf.now() : Date.now() - T0);
  const SESSION_S = 30 * 60; // sesja kończy się po 30 min bez ruchu
  const VISITOR_S = 395 * 86400; // 13 miesięcy
  const ACTIVE_GAP = 30000; // dłużej bez ruchu = czas nieaktywny (karta otwarta, nikt nie patrzy)
  const LIMIT = { click: 150, js_error: 10, gallery: 40, hover: 30, impression: 80, vital: 12, toggle: 40, variant: 30 };
  const PAGE = CFG.page || {};
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // --- drobne narzędzia
  const clip = (s, n = 80) => (s == null ? '' : String(s).replace(/\s+/g, ' ').trim().slice(0, n));
  const r2 = (n) => Math.round(n * 100) / 100;
  const ms = (n) => (typeof n === 'number' && isFinite(n) ? Math.round(n) : null);
  const rid = () => {
    const a = new Uint8Array(10);
    crypto.getRandomValues(a);
    return Array.from(a, (b) => (b % 36).toString(36)).join('');
  };
  const hash = (s) => {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0).toString(36);
  };
  const safe = (fn) =>
    function () {
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        return undefined;
      }
    };
  const cookie = {
    get(name) {
      const m = doc.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    },
    set(name, value, maxAge) {
      doc.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${
        location.protocol === 'https:' ? '; Secure' : ''
      }`;
    },
    del(name) {
      doc.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    },
  };

  const params = new URLSearchParams(location.search);
  if (params.get('ln_internal') === '1') cookie.set('_ln_int', '1', 365 * 86400);
  if (params.get('ln_internal') === '0') cookie.del('_ln_int');

  // --- urządzenie i przeglądarka (bez zapisywania całego user agenta)
  const ua = navigator.userAgent || '';
  const touchMac = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  const device =
    /iPad|Tablet/i.test(ua) || touchMac || (/Android/.test(ua) && !/Mobile/.test(ua))
      ? 'tablet'
      : /Mobi|iPhone|iPod|Android/i.test(ua)
      ? 'mobile'
      : 'desktop';
  const os = /iPhone|iPad|iPod/.test(ua) || touchMac
    ? 'iOS'
    : /Android/.test(ua)
    ? 'Android'
    : /Windows/.test(ua)
    ? 'Windows'
    : /Mac OS X/.test(ua)
    ? 'macOS'
    : /CrOS|Linux/.test(ua)
    ? 'Linux'
    : 'inne';
  const browser = /FBAN|FBAV|FB_IAB|FBIOS/.test(ua)
    ? 'Facebook'
    : /Instagram/.test(ua)
    ? 'Instagram'
    : /TikTok|musical_ly|Bytedance/i.test(ua)
    ? 'TikTok'
    : /Edg\//.test(ua)
    ? 'Edge'
    : /OPR\/|Opera/.test(ua)
    ? 'Opera'
    : /SamsungBrowser/.test(ua)
    ? 'Samsung'
    : /CriOS|Chrome\//.test(ua)
    ? 'Chrome'
    : /FxiOS|Firefox\//.test(ua)
    ? 'Firefox'
    : /Safari\//.test(ua)
    ? 'Safari'
    : 'inne';
  const theme = (window.Shopify && window.Shopify.theme) || {};
  // Bot przeglądu reklam Meta ma zwykłego Chrome'a w UA i nie ustawia webdriver; zdradza go strefa Kalifornii
  // (albo UTC jak inne przeglądarki bezgłowe) z angielskim – w polskim sklepie to nie klientka
  const tz = safe(() => Intl.DateTimeFormat().resolvedOptions().timeZone)() || '';
  const metaBot = /^(America\/Los_Angeles|UTC|Etc\/UTC)$/.test(tz) && /^en\b/i.test(navigator.language || '');
  const ctx = {
    path: location.pathname,
    tpl: PAGE.template || null,
    ptype: PAGE.type || null,
    th: theme.id || null,
    thn: theme.name || null,
    thr: theme.role || null,
    dev: device,
    os,
    br: browser,
    vw: window.innerWidth,
    vh: window.innerHeight,
    int: cookie.get('_ln_int') === '1',
    bot: !!navigator.webdriver || metaBot || /HeadlessChrome|Lighthouse|PageSpeed|bot|crawler|spider/i.test(ua),
    prev: !!theme.role && theme.role !== 'main',
  };

  // --- stan
  let on = false; // pomiar działa (jest zgoda)
  let wired = false;
  let vid = null;
  let sid = null;
  let sess = null; // { id, start, pages, camp, cart }
  let page = null; // bieżąca odsłona
  let queue = [];
  let lastTouch = 0;
  const cart = { items: null, total: null, lines: null };

  const newPage = () => ({
    pid: rid(),
    t0: since(),
    seq: 0,
    counts: {},
    tick: since(),
    lastAct: since(),
    active: 0,
    maxY: 0,
    docH: 0,
    milestones: new Set(),
    dwell: new Map(), // klucz sekcji/strefy -> ms w widoku (tylko czas aktywny)
    inView: new Set(),
    order: [],
    lastSeen: null,
    clicks: 0,
    adds: 0,
    lastClick: null,
    summaries: 0,
    lastSummary: -1e9,
    errors: new Set(),
    forms: new WeakSet(),
    gallery: new Map(),
    shown: new Set(),
  });

  // --- wysyłka: paczki tekstem (bez preflight CORS), przy chowaniu strony przez sendBeacon
  const send = (body, beacon) => {
    try {
      if (beacon && navigator.sendBeacon && navigator.sendBeacon(CFG.endpoint, new Blob([body], { type: 'text/plain' })))
        return;
      if (!nativeFetch) return;
      nativeFetch(CFG.endpoint, {
        method: 'POST',
        body,
        keepalive: body.length < 60000,
        mode: 'no-cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' },
      }).catch(() => {});
    } catch (e) {}
  };

  const flush = (beacon) => {
    if (!queue.length || !vid || !page) return;
    while (queue.length) {
      const e = queue.splice(0, 30);
      send(JSON.stringify({ v: 1, shop: CFG.shop, src: 'theme', vid, sid, pid: page.pid, to: T0, now: Date.now(), ctx, e }), beacon);
    }
  };

  const writeSession = () => {
    if (!sess) return;
    cookie.set('_ln_s', [sess.id, sess.start, sess.pages, sess.camp, sess.cart ? 1 : 0].join('.'), SESSION_S);
  };
  const touchSession = () => {
    const t = Date.now();
    if (t - lastTouch > 20000) {
      lastTouch = t;
      writeSession();
    }
  };

  const emit = (name, props) => {
    if (!on || !page) return;
    page.counts[name] = (page.counts[name] || 0) + 1;
    if (LIMIT[name] && page.counts[name] > LIMIT[name]) return;
    queue.push({ n: name, t: since(), s: ++page.seq, p: props || {} });
    touchSession();
    if (doc.visibilityState === 'hidden') flush(true);
    else if (queue.length >= 25) flush(false);
  };

  // --- sesja i odwiedzająca
  const campaign = () => {
    const utm = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach((k) => {
      const v = params.get('utm_' + k);
      if (v) utm[k] = clip(v, 100);
    });
    const click = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid'].filter((k) => params.has(k));
    const key =
      Object.keys(utm).length || click.length ? hash(JSON.stringify([utm.source, utm.medium, utm.campaign, click.join()])) : '';
    return { utm, click, key };
  };

  const referrer = () => {
    try {
      if (!doc.referrer) return null;
      const u = new URL(doc.referrer);
      return u.host === location.host ? null : u.host;
    } catch (e) {
      return null;
    }
  };

  const begin = (how) => {
    const t = Date.now();
    const day = Math.floor(t / 86400000);
    const vc = (cookie.get('_ln_v') || '').split('.');
    const isNew = !vc[0];
    const v = isNew ? { id: rid(), first: day, n: 0 } : { id: vc[0], first: +vc[1] || day, n: +vc[2] || 0 };
    const sc = (cookie.get('_ln_s') || '').split('.');
    sess = sc[0] ? { id: sc[0], start: +sc[1] || 0, pages: +sc[2] || 0, camp: sc[3] || '', cart: sc[4] === '1' } : null;
    const camp = campaign();
    let started = false;
    // nowa sesja: po 30 min bez ruchu (ciasteczko wygasło) albo wejście z innej kampanii
    if (!sess || (camp.key && camp.key !== sess.camp)) {
      v.n += 1;
      sess = { id: rid(), start: Math.floor(t / 1000), pages: 0, camp: camp.key, cart: false };
      started = true;
    }
    sess.pages += 1;
    vid = v.id;
    sid = sess.id;
    cookie.set('_ln_v', [v.id, v.first, v.n].join('.'), VISITOR_S);
    lastTouch = t;
    writeSession();
    return { started, isNew, visit: v.n, days: day - v.first, camp, ref: referrer(), how };
  };

  const navType = () => {
    try {
      const n = perf.getEntriesByType('navigation')[0];
      return n ? n.type : null;
    } catch (e) {
      return null;
    }
  };

  const rootState = () => {
    const st = {};
    Object.entries(CFG.state || {}).forEach(([k, attr]) => {
      const v = root.getAttribute(attr);
      if (v != null) st[k] = v;
    });
    return st;
  };

  const pageView = (s, nav) => {
    if (s.started) {
      const conn = navigator.connection || {};
      emit('session_start', {
        land: location.pathname,
        ref: s.ref,
        utm: s.camp.utm,
        click: s.camp.click,
        visit: s.visit,
        new: s.isNew,
        days: s.days,
        lang: clip(navigator.language, 12),
        tz: clip((Intl.DateTimeFormat().resolvedOptions() || {}).timeZone, 40),
        dpr: r2(window.devicePixelRatio || 1),
        sw: screen.width,
        sh: screen.height,
        touch: navigator.maxTouchPoints > 0,
        net: conn.effectiveType || null,
        save: conn.saveData || false,
        consent: s.how,
      });
    }
    const posted =
      params.get('contact_posted') === 'true' ? 'contact' : params.get('customer_posted') === 'true' ? 'newsletter' : null;
    emit('page_view', {
      title: clip(doc.title, 120),
      ref: s.ref,
      nav,
      n: sess.pages,
      st: rootState(),
      pr: PAGE.product || null,
      col: PAGE.collection || null,
      q: PAGE.search || null,
      posted,
      exp: window.LN_EXP || null,
      consent: s.how,
    });
    if (posted) emit('form_success', { form: posted });
  };

  // --- gdzie jest element: sekcja Shopify, strefa z konfiguracji, czytelna nazwa, selektor od sekcji
  const sectionKey = (el) => {
    const s = el.closest('.shopify-section');
    if (s && s.id) return s.id.replace(/^shopify-section-/, '').split('__').pop();
    if (el.closest('cart-drawer')) return 'koszyk';
    if (el.closest('#shopify-pc__banner')) return 'baner_cookie';
    if (el.closest('dialog, [role="dialog"]')) return 'okno'; // okna aplikacji (np. wybór dostawy InPost)
    return 'inne';
  };

  // strefa: [selektor, nazwa, czy liczyć jej oglądanie (domyślnie tak; false = tylko podpis kliknięć, np. kafle)]
  const ZONES = (CFG.zones || []).map(([sel, name, area]) => ({ sel, name, area: area !== false }));
  const zoneName = (el, name) => {
    if (name.indexOf('{summary}') < 0) return name;
    const s = el.querySelector('summary');
    return name.replace('{summary}', clip(s ? s.innerText : '', 40));
  };
  const zoneCache = new WeakMap();
  const zoneOf = (el) => {
    if (zoneCache.has(el)) return zoneCache.get(el);
    let z = null;
    for (let n = el; n && n !== doc.body && !z; n = n.parentElement) {
      for (const zone of ZONES) {
        if (n.matches(zone.sel)) {
          z = zoneName(n, zone.name);
          break;
        }
      }
    }
    zoneCache.set(el, z);
    return z;
  };

  const label = (el) => {
    if (!el) return '';
    const own = el.closest('[data-ln-a]');
    if (own) return clip(own.getAttribute('data-ln-a'), 60);
    const aria = el.getAttribute('aria-label');
    if (aria) return clip(aria, 60);
    // etykieta wariantu (karty długości): wartość opcji, bez ukrytych dopisków typu „wyprzedany”
    if (el.matches('label') && el.control && /radio|checkbox/.test(el.control.type)) return clip(el.control.value, 60);
    if (el.matches('input, select, textarea')) {
      const lab = el.labels && el.labels[0] ? el.labels[0].innerText : '';
      if (el.type === 'radio' || el.type === 'checkbox') return clip(lab || el.value, 60);
      return clip(lab || el.placeholder || el.name || el.type, 60); // nigdy wartość pola
    }
    if (PAGE.private) return el.tagName.toLowerCase();
    const img = el.matches('img') ? el : el.querySelector('img[alt]');
    return clip(el.innerText || el.getAttribute('title') || (img && img.alt) || el.getAttribute('name') || el.tagName.toLowerCase(), 60);
  };

  const cssPath = (el) => {
    const parts = [];
    for (let n = el, d = 0; n && n !== doc.body && d < 7; n = n.parentElement, d++) {
      if (n.classList.contains('shopify-section')) break;
      // getAttribute, bo form.id zwraca pole <input name="id"> formularza produktu
      const id = n.getAttribute('id');
      if (id && !/\d{5,}/.test(id)) {
        parts.unshift('#' + CSS.escape(id));
        break;
      }
      let p = n.tagName.toLowerCase();
      // bez klas stanu i klas z numerem szablonu (zmieniają się między kopiami motywu)
      const cls = Array.from(n.classList).find(
        (c) => !/^(is-|js-|active|animate|loading|hidden|focus|scroll-trigger|gradient|color-)/.test(c) && !/\d{5,}/.test(c)
      );
      if (cls) p += '.' + CSS.escape(cls);
      const par = n.parentElement;
      if (par) {
        const same = Array.from(par.children).filter((c) => c.tagName === n.tagName);
        if (same.length > 1) p += `:nth-of-type(${same.indexOf(n) + 1})`;
      }
      parts.unshift(p);
    }
    return parts.join(' > ');
  };

  const itemOf = (el) => {
    const a = el.matches('a[href]') ? el : el.querySelector('a[href*="/products/"], a[href*="/collections/"], a[href]');
    if (a) {
      try {
        const p = new URL(a.href, location.href).pathname;
        const m = p.match(/\/(products|collections)\/([^/?#]+)/);
        return m ? m[2] : clip(p, 60);
      } catch (e) {}
    }
    return clip(el.getAttribute('data-ln-item') || label(el), 40);
  };

  // --- sekcje i strefy w widoku
  const areaKeys = new WeakMap();
  const areaEls = [];
  let areaIO = null;
  const onArea = safe((entries) => {
    for (const en of entries) {
      const key = areaKeys.get(en.target);
      if (!key) continue;
      const h = en.boundingClientRect.height;
      const vis =
        en.isIntersecting && h > 2 && (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= window.innerHeight * 0.3);
      if (!vis) {
        page.inView.delete(key);
        continue;
      }
      page.inView.add(key);
      page.lastSeen = key;
      if (!page.dwell.has(key)) {
        page.dwell.set(key, 0);
        page.order.push(key);
        const zone = key.indexOf('>') > 0;
        emit(zone ? 'zone_view' : 'section_view', {
          k: key,
          i: page.order.length,
          top: Math.round(en.boundingClientRect.top + window.scrollY),
          at: Math.round(window.scrollY),
        });
      }
    }
  });
  const scanAreas = safe(() => {
    if (!areaIO) areaIO = new IntersectionObserver(onArea, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
    const add = (el, key) => {
      areaKeys.set(el, key);
      areaEls.push(el);
      areaIO.observe(el);
    };
    doc.querySelectorAll('.shopify-section').forEach((el) => {
      if (!areaKeys.has(el)) add(el, sectionKey(el));
    });
    ZONES.forEach((z) => {
      if (!z.area) return;
      doc.querySelectorAll(z.sel).forEach((el) => {
        if (!areaKeys.has(el) && !el.closest('cart-drawer')) add(el, sectionKey(el) + '>' + zoneName(el, z.name));
      });
    });
  });

  // --- kafle produktów: wyświetlenie (≥ 50 % kafla) i pozycja w sekcji
  let tileIO = null;
  let tiles = new WeakSet();

  // nowa odsłona bez przeładowania (bfcache, ponowna zgoda): obserwatory muszą zgłosić stan od zera
  const reobserve = safe(() => {
    if (areaIO)
      areaEls.forEach((el) => {
        areaIO.unobserve(el);
        if (el.isConnected) areaIO.observe(el);
      });
    tiles = new WeakSet();
    scanAreas();
    scanTiles();
  });
  const scanTiles = safe(() => {
    if (!CFG.impressions) return;
    if (!tileIO)
      tileIO = new IntersectionObserver(
        safe((entries) => {
          for (const en of entries) {
            if (!en.isIntersecting || en.intersectionRatio < 0.5) continue;
            tileIO.unobserve(en.target);
            const el = en.target;
            const sec = el.closest('.shopify-section') || el.closest('cart-drawer') || doc.body;
            const pos = Array.from(sec.querySelectorAll(CFG.impressions)).indexOf(el) + 1;
            emit('impression', { item: itemOf(el), list: sectionKey(el), pos });
          }
        }),
        { threshold: [0.5] }
      );
    doc.querySelectorAll(CFG.impressions).forEach((el) => {
      if (tiles.has(el)) return;
      tiles.add(el);
      tileIO.observe(el);
    });
  });

  // --- czas aktywny i czas w sekcjach (co sekundę, tylko gdy strona widoczna i ktoś się ruszał w ostatnich 30 s)
  const tick = () => {
    if (!on || !page) return;
    const t = since();
    const d = Math.min(t - page.tick, 2000);
    page.tick = t;
    if (doc.visibilityState !== 'visible' || t - page.lastAct > ACTIVE_GAP || d <= 0) return;
    page.active += d;
    page.inView.forEach((k) => page.dwell.set(k, (page.dwell.get(k) || 0) + d));
  };
  const activity = () => {
    if (page) page.lastAct = since();
  };

  // --- przewinięcie
  let scrollRaf = 0;
  const measureScroll = safe(() => {
    scrollRaf = 0;
    const y = window.scrollY + window.innerHeight;
    const h = Math.max(root.scrollHeight, 1);
    if (y > page.maxY) page.maxY = y;
    page.docH = h;
    const pct = Math.min(100, Math.round((page.maxY / h) * 100));
    for (const m of [25, 50, 75, 90]) {
      if (pct >= m && !page.milestones.has(m)) {
        page.milestones.add(m);
        emit('scroll', { pct: m });
      }
    }
  });
  const onScroll = () => {
    if (!on || !page) return;
    activity();
    if (!scrollRaf) scrollRaf = requestAnimationFrame(measureScroll);
  };

  // --- podsumowanie odsłony (wysyłane przy każdym schowaniu strony; w analizie liczy się ostatnie)
  const summary = (why) => {
    if (!on || !page) return;
    tick();
    if (since() - page.lastSummary < 1000) return; // visibilitychange i pagehide zwykle lecą razem
    page.lastSummary = since();
    page.summaries += 1;
    const dw = {};
    page.dwell.forEach((v, k) => {
      if (v > 0) dw[k] = Math.round(v);
    });
    const h = Math.max(page.docH || root.scrollHeight, 1);
    const recent = page.lastClick && since() - page.lastClick.t < 3000 ? page.lastClick : null;
    emit('page_summary', {
      n: page.summaries,
      why,
      act: Math.round(page.active),
      tot: since() - page.t0,
      sp: Math.min(100, Math.round((page.maxY / h) * 100)),
      sy: Math.round(page.maxY),
      dh: Math.round(h),
      seen: page.order.slice(0, 40),
      last: page.lastSeen,
      dw,
      cl: page.clicks,
      adds: page.adds,
      out: recent ? recent.href || null : null,
    });
  };

  // --- kliknięcia, martwe i wściekłe
  const INTERACTIVE =
    'a[href], button, input, select, textarea, label, summary, [role="button"], [role="link"], [role="tab"], [role="option"], [onclick], [tabindex]:not([tabindex="-1"]), [data-ln-a]' +
    (CFG.interactive ? ', ' + CFG.interactive : '');
  let burst = [];

  const watchDead = (p) => {
    const href = location.href;
    const y0 = window.scrollY;
    let changed = false;
    const mo = new MutationObserver((records) => {
      for (const r of records) {
        const t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        if (t && CFG.noisy && t.closest(CFG.noisy)) continue; // licznik, przyklejony nagłówek itp. zmieniają się same
        changed = true;
        mo.disconnect();
        return;
      }
    });
    mo.observe(doc.body, { subtree: true, childList: true, attributes: true, characterData: true });
    setTimeout(
      safe(() => {
        mo.disconnect();
        const sel = window.getSelection ? String(window.getSelection()) : '';
        if (changed || sel || location.href !== href || Math.abs(window.scrollY - y0) > 4 || doc.visibilityState !== 'visible')
          return;
        emit('dead_click', { el: p.el, tag: p.tag, sec: p.sec, z: p.z, sel: p.sel, rx: p.rx, ry: p.ry });
      }),
      1000
    );
  };

  const onClick = safe((e) => {
    // !isTrusted: kliknięcia wywołane skryptem (np. InPost zamyka szufladę, klikając „Zamknij”) – to nie klientka
    if (!on || !page || !e.isTrusted || !(e.target instanceof Element)) return;
    activity();
    const hit = e.target.closest(INTERACTIVE);
    const el = hit || e.target;
    // kliknięcie w <label> przeglądarka powtarza na jego polu (np. karty długości) – liczymy tylko etykietę
    if (page.label && page.label.ctl === el && since() - page.label.t < 150) return;
    page.label = el.matches('label') && el.control ? { ctl: el.control, t: since() } : null;
    const sec = sectionKey(el);
    const z = zoneOf(el);
    const lab = label(el);
    const p = { el: lab, tag: el.tagName.toLowerCase(), sec, z, sel: cssPath(el), i: !!hit };
    const r = el.getBoundingClientRect();
    const kb = e.detail === 0 && e.clientX === 0 && e.clientY === 0;
    if (kb) p.kb = true;
    else if (r.width && r.height) {
      p.rx = r2(Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1));
      p.ry = r2(Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1));
      p.x = Math.round(e.clientX + window.scrollX);
      p.y = Math.round(e.clientY + window.scrollY);
      p.dw = root.clientWidth;
    }
    const link = el.closest('a[href]');
    if (link) {
      try {
        const u = new URL(link.href, location.href);
        if (u.host !== location.host) p.ext = u.host;
        else p.href = u.pathname;
      } catch (err) {}
    }
    page.clicks += 1;
    page.lastClick = { t: since(), sec, z, el: lab, href: p.href || p.ext || null };
    emit('click', p);
    if (el.closest(CFG.checkout || '[name="checkout"], .cart__checkout-button, a[href*="/checkout"]'))
      emit('checkout_click', { sec, z, items: cart.items, total: cart.total });
    if (!kb) {
      const t = since();
      burst = burst.filter((b) => t - b.t < 800 && Math.abs(b.x - e.clientX) < 40 && Math.abs(b.y - e.clientY) < 40);
      burst.push({ t, x: e.clientX, y: e.clientY });
      if (burst.length === 3) emit('rage_click', { el: lab, tag: p.tag, sec, z, sel: p.sel, i: !!hit });
    }
    if (!hit && !kb) watchDead(p);
  });

  // --- koszyk: każde zapytanie /cart/* przechodzi przez fetch (Dawn: product-form.js, cart.js)
  const bodyOf = (b) => {
    try {
      if (!b) return {};
      if (typeof b === 'string') return JSON.parse(b);
      if (b instanceof FormData) {
        const o = {};
        b.forEach((v, k) => {
          if (typeof v === 'string' && !(k in o)) o[k] = v;
        });
        return o;
      }
      if (b instanceof URLSearchParams) return Object.fromEntries(b);
    } catch (e) {}
    return {};
  };

  const setCart = (c) => {
    if (!c || c.item_count == null) return;
    cart.items = c.item_count;
    cart.total = c.total_price / 100;
    if (Array.isArray(c.items)) cart.lines = c.items.map((it) => ({ h: it.handle, v: it.variant_id, q: it.quantity }));
  };
  const refreshCart = () => {
    if (!nativeFetch) return Promise.resolve();
    return nativeFetch(shopRoot + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(setCart)
      .catch(() => {});
  };

  // ukryte atrybuty koszyka (z „_” – klientka ich nie widzi): zamówienie w Shopify niesie identyfikatory sesji
  const tagCart = () => {
    if (!sess || sess.cart || !nativeFetch || !cart.items) return;
    sess.cart = true;
    writeSession();
    nativeFetch(shopRoot + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _ln_v: vid, _ln_s: sid } }),
    }).catch(() => {
      sess.cart = false;
      writeSession();
    });
  };

  const onCart = safe((kind, req, json, from) => {
    const src = from ? { sec: from.sec, z: from.z, el: from.el } : {};
    if (!json) return;
    if (json.status && (json.description || json.message)) {
      emit('cart_error', { kind, msg: clip(json.description || json.message, 160), ...src });
      return;
    }
    if (kind === 'add') {
      const items = Array.isArray(json.items) ? json.items : [json];
      items.forEach((it) => {
        if (!it || !it.variant_id) return;
        emit('cart_add', {
          h: it.handle,
          v: it.variant_id,
          pt: clip(it.product_title, 80),
          vt: clip(it.variant_title, 40),
          q: parseInt(req.quantity, 10) || 1,
          price: it.final_price / 100,
          ...src,
        });
        page.adds += 1;
      });
      refreshCart().then(tagCart);
    } else if (kind === 'change') {
      const q = Number(req.quantity);
      const line = parseInt(req.line, 10);
      const before = cart.lines && line > 0 ? cart.lines[line - 1] : null;
      emit(q === 0 ? 'cart_remove' : 'cart_qty', {
        h: before ? before.h : null,
        from: before ? before.q : null,
        q,
        items: json.item_count,
        total: json.total_price / 100,
        ...src,
      });
      setCart(json);
    } else {
      setCart(json);
    }
  });

  const wrapFetch = () => {
    const orig = window.fetch;
    if (!orig || orig.__ln) return;
    const wrapped = function (input, init) {
      const res = orig.apply(this, arguments);
      try {
        const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
        const m = url && url.match(/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/);
        if (m && on) {
          const req = bodyOf(init && init.body);
          const from = page && page.lastClick && since() - page.lastClick.t < 4000 ? page.lastClick : null;
          res
            .then((r) => r.clone().json())
            .then((json) => onCart(m[1], req, json, from))
            .catch(() => {});
        }
      } catch (e) {}
      return res;
    };
    wrapped.__ln = true;
    window.fetch = wrapped;
  };

  const watchDrawer = safe(() => {
    const drawer = doc.querySelector('cart-drawer');
    if (!drawer) return;
    let openedAt = 0;
    new MutationObserver(
      safe(() => {
        const open = drawer.classList.contains('active');
        if (open && !openedAt) {
          openedAt = since();
          const from = page.lastClick && since() - page.lastClick.t < 3000 ? page.lastClick.z || page.lastClick.sec : null;
          refreshCart().then(() => {
            emit('cart_open', { items: cart.items, total: cart.total, from });
            tagCart();
          });
        } else if (!open && openedAt) {
          emit('cart_close', { ms: since() - openedAt, items: cart.items });
          openedAt = 0;
        }
      })
    ).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  });

  // --- elementy, które się pojawiają (przyklejony pasek zakupu, okno wyboru dostawy): raz na odsłonę każdy;
  // okna dokładane później przez aplikacje łapie ponowne skanowanie (MutationObserver w wire)
  const watched = new WeakSet();
  const watchShown = safe(() => {
    (CFG.watch || []).forEach(([sel, attr, name]) =>
      doc.querySelectorAll(sel).forEach((el) => {
        if (watched.has(el)) return;
        watched.add(el);
        const check = safe(() => {
          if (!el.hasAttribute(attr) || !page || page.shown === undefined) return;
          if (page.shown.has(name)) return;
          page.shown.add(name);
          emit('ui_show', { el: name, sec: sectionKey(el) });
        });
        new MutationObserver(check).observe(el, { attributes: true, attributeFilter: [attr] });
        check();
      })
    );
  });

  // --- szybkość: web-vitals (Google, Apache-2.0) z atrybucją, dociągany dopiero po zgodzie
  const vital = safe((m) => {
    const a = Object.assign({}, m.attribution);
    const path = (u) => clip(String(u || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0], 120);
    // selektory web-vitals biorą form.id – w formularzu produktu to pole <input name="id">
    ['target', 'interactionTarget', 'largestShiftTarget'].forEach((k) => {
      if (typeof a[k] === 'string') a[k] = a[k].replace(/#\[object [A-Za-z]+\]/g, 'form');
    });
    const p = { name: m.name, v: m.name === 'CLS' ? Math.round(m.value * 1000) / 1000 : Math.round(m.value), r: m.rating, nav: m.navigationType };
    if (m.name === 'LCP')
      Object.assign(p, {
        el: clip(a.target, 120),
        url: path(a.url),
        ttfb: ms(a.timeToFirstByte),
        ld: ms(a.resourceLoadDelay),
        lt: ms(a.resourceLoadDuration),
        rd: ms(a.elementRenderDelay),
      });
    if (m.name === 'INP')
      Object.assign(p, {
        el: clip(a.interactionTarget, 120),
        type: a.interactionType,
        id: ms(a.inputDelay),
        pd: ms(a.processingDuration),
        pr: ms(a.presentationDelay),
      });
    if (m.name === 'CLS') p.el = clip(a.largestShiftTarget, 120);
    emit('vital', p);
  });
  const loadVitals = () => {
    if (!CFG.vitals || window.webVitals) return;
    const s = doc.createElement('script');
    s.src = CFG.vitals;
    s.async = true;
    s.onload = safe(() => {
      const wv = window.webVitals;
      if (!wv) return;
      ['onLCP', 'onCLS', 'onINP', 'onFCP', 'onTTFB'].forEach((f) => wv[f] && wv[f](vital));
    });
    doc.head.appendChild(s);
  };

  // --- nasłuch na całym dokumencie (raz; każdy sprawdza, czy pomiar działa)
  const wire = () => {
    wired = true;
    ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach((t) => window.addEventListener(t, activity, { passive: true, capture: true }));
    let lastMove = 0;
    window.addEventListener(
      'mousemove',
      () => {
        const t = Date.now();
        if (t - lastMove > 2000) {
          lastMove = t;
          activity();
        }
      },
      { passive: true }
    );
    window.addEventListener('scroll', onScroll, { passive: true });
    setInterval(safe(tick), 1000);
    setInterval(() => on && queue.length && flush(false), 15000);

    doc.addEventListener(
      'toggle',
      safe((e) => {
        const d = e.target;
        if (!on || !(d instanceof HTMLDetailsElement)) return;
        const s = d.querySelector('summary');
        emit('toggle', { el: clip(s ? s.getAttribute('aria-label') || s.innerText : '', 80), open: d.open, sec: sectionKey(d), z: zoneOf(d) });
      }),
      true
    );

    doc.addEventListener(
      'change',
      safe((e) => {
        const t = e.target;
        if (!on || !(t instanceof Element) || !t.closest(CFG.variants || 'variant-selects')) return;
        emit('variant', { opt: clip(t.name, 40), val: clip(t.value, 60), h: PAGE.product ? PAGE.product.h : null, sec: sectionKey(t) });
      }),
      true
    );

    const formName = (f) => {
      const type = f.querySelector('[name="form_type"]');
      if (type) return clip(type.value, 40);
      const id = f.getAttribute('id');
      if (id && !/\d{5,}/.test(id)) return clip(id, 40);
      return clip((f.getAttribute('action') || 'form').split('?')[0], 40);
    };
    doc.addEventListener(
      'submit',
      safe((e) => {
        const f = e.target;
        if (!on || !(f instanceof HTMLFormElement)) return;
        const name = formName(f);
        if (name === 'product') return; // dodanie do koszyka liczy cart_add
        emit('form_submit', { form: name, sec: sectionKey(f) });
      }),
      true
    );
    doc.addEventListener(
      'focusin',
      safe((e) => {
        const t = e.target;
        if (!on || !(t instanceof Element) || !t.matches('input:not([type="hidden"]), textarea, select')) return;
        const f = t.closest('form');
        if (!f || page.forms.has(f)) return;
        page.forms.add(f);
        const name = formName(f);
        if (name !== 'product') emit('form_start', { form: name, field: clip(t.name, 40), sec: sectionKey(f) });
      }),
      true
    );

    doc.addEventListener(
      'slideChanged',
      safe((e) => {
        const s = e.target;
        const d = e.detail || {};
        if (!on || !(s instanceof Element)) return;
        const id = clip((s.id || s.tagName).split('-')[0], 30);
        if (page.gallery.get(id) === d.currentPage) return;
        page.gallery.set(id, d.currentPage);
        emit('gallery', { id, i: d.currentPage, n: s.totalPages || null, sec: sectionKey(s), z: zoneOf(s) });
      }),
      true
    );

    (CFG.events || []).forEach(([type, name, fields]) =>
      doc.addEventListener(
        type,
        safe((e) => {
          if (!on) return;
          const d = e.detail || {};
          const p = {};
          (fields || []).forEach((f) => {
            if (d[f] !== undefined) p[f] = d[f];
          });
          if (page.lastClick && since() - page.lastClick.t < 1500) {
            p.sec = page.lastClick.sec;
            p.z = page.lastClick.z;
          }
          emit(name, p);
        })
      )
    );

    if (CFG.hover && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      const hovered = new Map();
      doc.addEventListener(
        'pointerover',
        safe((e) => {
          if (!on || e.pointerType !== 'mouse' || !(e.target instanceof Element)) return;
          const el = e.target.closest(CFG.hover);
          if (!el || hovered.has(el)) return;
          hovered.set(el, since());
          const leave = safe(() => {
            el.removeEventListener('pointerleave', leave);
            const t = since() - hovered.get(el);
            hovered.delete(el);
            if (t >= 400) emit('hover', { item: itemOf(el), sec: sectionKey(el), ms: t });
          });
          el.addEventListener('pointerleave', leave);
        }),
        true
      );
    }

    window.addEventListener(
      'error',
      safe((e) => {
        if (!on) return;
        const t = e.target;
        if (t && t !== window && t.tagName) {
          const src = clip(String(t.currentSrc || t.src || t.href || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0], 140);
          if (page.errors.has(src)) return;
          page.errors.add(src);
          emit('js_error', { kind: 'resource', tag: t.tagName.toLowerCase(), src });
          return;
        }
        const key = clip(e.message, 200) + '|' + (e.filename || '');
        if (page.errors.has(key)) return;
        page.errors.add(key);
        emit('js_error', {
          kind: 'error',
          msg: clip(e.message, 200),
          src: clip(String(e.filename || '').split('/').pop().split('?')[0], 80),
          line: e.lineno || null,
          col: e.colno || null,
        });
      }),
      true
    );
    window.addEventListener(
      'unhandledrejection',
      safe((e) => {
        if (!on) return;
        const r = e.reason;
        const msg = clip(r && r.message ? r.message : r, 200);
        if (page.errors.has(msg)) return;
        page.errors.add(msg);
        emit('js_error', { kind: 'promise', msg });
      })
    );

    doc.addEventListener('visibilitychange', () => {
      if (!on || !page) return;
      if (doc.visibilityState === 'hidden') {
        summary('hidden');
        flush(true);
      } else {
        page.tick = since();
        activity();
      }
    });
    window.addEventListener('pagehide', () => {
      if (!on) return;
      summary('pagehide');
      flush(true);
    });
    // powrót strzałką z pamięci przeglądarki (bfcache): nowa odsłona bez przeładowania
    window.addEventListener(
      'pageshow',
      safe((e) => {
        if (!on || !e.persisted) return;
        page = newPage();
        page.maxY = window.scrollY + window.innerHeight;
        pageView(begin('stored'), 'back_forward');
        reobserve();
      })
    );

    // Dawn podmienia fragmenty karty (cena, przyciski, wybór wariantu) po zmianie wariantu – nowe węzły też obserwujemy
    let rescan = 0;
    new MutationObserver(() => {
      if (!on || rescan) return;
      rescan = setTimeout(() => {
        rescan = 0;
        scanAreas();
        scanTiles();
        watchShown();
      }, 400);
    }).observe(doc.body, { childList: true, subtree: true });
  };

  const start = safe((how) => {
    if (on) return;
    on = true;
    page = newPage();
    const s = begin(how);
    const first = !wired;
    if (first) wire();
    page.maxY = window.scrollY + window.innerHeight;
    pageView(s, navType());
    if (first) {
      scanAreas();
      scanTiles();
      watchShown();
      watchDrawer();
      wrapFetch();
      loadVitals();
    } else reobserve();
    if (PAGE.type === 'cart') refreshCart().then(tagCart);
  });

  const stop = () => {
    if (on) {
      summary('stop');
      flush(true);
    }
    on = false;
    queue = [];
    vid = sid = sess = null;
    cookie.del('_ln_v');
    cookie.del('_ln_s');
  };

  // --- zgoda (Shopify Customer Privacy API): bez zgody na analitykę nic się nie dzieje
  const allowed = () => {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      return cp && typeof cp.analyticsProcessingAllowed === 'function' ? !!cp.analyticsProcessingAllowed() : null;
    } catch (e) {
      return null;
    }
  };
  const check = () => {
    const a = allowed();
    if (a === true) start('stored');
    else if (a === false && cookie.get('_ln_v')) stop(); // zgoda cofnięta gdzie indziej
  };
  // Kliknięcia: od razu (nie dopiero po zgodzie) i na window, przed aplikacjami. InPost (wersja 168, zauważone 1.11.2026)
  // łapie „Przejdź do kasy” na window w fazie przechwytywania i zatrzymuje zdarzenie – nasłuch na document go nie
  // widział. Ten skrypt (defer w <head>, przed content_for_header) wykonuje się przed skryptami aplikacji.
  window.addEventListener('click', onClick, true);
  doc.addEventListener('visitorConsentCollected', (e) => {
    const d = (e && e.detail) || {};
    if (d.analyticsAllowed) start('now');
    else if (d.analyticsAllowed === false) stop();
  });
  if (allowed() !== null) check();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function')
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
      if (!err) check();
    });

  window.LnAnalityka = {
    // własne zdarzenia z motywu: LnAnalityka.track('nazwa_zdarzenia', { ... })
    track: (name, props) => /^[a-z_]{2,32}$/.test(name) && emit(name, props),
    flush: () => flush(false),
    get on() {
      return on;
    },
  };
})();
